import React, { useMemo } from "react";

/**
 * Small SVG sparkline for mood history.
 * `series` is [{ date, mood: 1..5 or null }, ...]
 */
export default function MoodSpark({ series = [], height = 44, testid = "mood-spark" }) {
  const points = useMemo(() => {
    if (!series.length) return [];
    const w = 300;
    const h = height;
    const step = w / Math.max(1, series.length - 1);
    return series.map((s, i) => {
      const x = i * step;
      const m = s.mood;
      if (m == null) return null;
      const y = h - ((m - 1) / 4) * (h - 6) - 3; // pad top/bottom by 3
      return { x, y, m };
    });
  }, [series, height]);

  const drawable = points.filter(Boolean);
  if (drawable.length < 2) {
    return (
      <div className="text-xs text-muted italic" data-testid={`${testid}-empty`}>
        {drawable.length === 0 ? "no mood data yet" : "check in a bit more to see your trend"}
      </div>
    );
  }
  const path = drawable
    .map((p, i) => `${i === 0 ? "M" : "L"}${p.x.toFixed(1)},${p.y.toFixed(1)}`)
    .join(" ");
  return (
    <svg viewBox={`0 0 300 ${height}`} className="w-full h-auto" data-testid={testid}>
      <defs>
        <linearGradient id="moodFill" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="var(--primary)" stopOpacity="0.25" />
          <stop offset="100%" stopColor="var(--primary)" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path
        d={`${path} L${drawable[drawable.length - 1].x},${height} L${drawable[0].x},${height} Z`}
        fill="url(#moodFill)"
      />
      <path d={path} stroke="var(--primary)" strokeWidth="1.75" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      {drawable.map((p, i) => (
        <circle key={i} cx={p.x} cy={p.y} r="2.4" fill="var(--primary)" />
      ))}
    </svg>
  );
}
